import { Component, Event, EventEmitter, h, Prop, State } from '@stencil/core';
import { i18nConfig } from '../../../../../interfaces';
import fitText from '../../../../../library/fittext.js';

@Component({
  tag: 'presto-email-overlay-ui',
  styleUrl: 'presto-email-overlay-ui.scss',
  shadow: true,
})
export class EmailOverlayUI {
  private textInput?: HTMLInputElement;

  /**
   * Props
   */
  @Prop() headline: string;
  @Prop() bottomText: string;
  @Prop() buttonText: string;
  @Prop() allowSkip: boolean;
  @Prop() borderRadius: number;
  @Prop() isLoading: boolean;
  @Prop() errorMessage: string;
  @Prop() direction?: 'rtl';
  @Prop() i18n: i18nConfig;
  @Prop() provider: string;
  @Prop() type: string;

  /**
   * State
   */
  @State() email: string;
  @State() isAudioProvider: boolean;

  /**
   * Events
   */
  @Event() submitForm: EventEmitter<object>;
  @Event() skip: EventEmitter<object>;

  /**
   * Handle form submission
   * @param e Event
   */
  handleSubmit(e) {
    this.submitForm.emit({
      email: this.email,
    });
    e.preventDefault();
  }

  componentDidLoad() {
    let currentType = this.type || this.provider;
    this.isAudioProvider = currentType === 'audio' ? true : false;
    fitText(this.textInput, 3, {
      maxFontSize: this.isAudioProvider ? 15 : 20,
      minFontSize: 8,
    });
  }

  /**
   * Handle input change
   * @param e Event
   */
  handleChange(e) {
    this.email = e.target.value;
  }

  render() {
    return (
      <div class={`overlay ${this.direction === 'rtl' ? 'rtl' : ''}`} ref={el => (this.textInput = el as HTMLInputElement)}>
        <div class="content">
          <h1 class={this.isAudioProvider && 'is-small'}>{this.headline || this?.i18n?.emailDefaultHeadline}</h1>
          {this.isLoading ? (
            <presto-player-spinner></presto-player-spinner>
          ) : (
            <form onSubmit={e => this.handleSubmit(e)}>
              <input type="email" placeholder={this?.i18n?.emailPlaceholder} value={this.email} onInput={event => this.handleChange(event)} required></input>
              <button type="submit">{this.buttonText || this?.i18n?.play}</button>
            </form>
          )}
          {this.errorMessage && <p class="error">{this.errorMessage}</p>}
          {this.bottomText && <p innerHTML={this.bottomText} class={this.isAudioProvider && 'is-small'}></p>}
          {!!this.allowSkip && (
            <div
              class="skip"
              onClick={() => {
                this.skip.emit();
              }}
            >
              {this?.i18n?.skip} &rarr;
            </div>
          )}
        </div>
      </div>
    );
  }
}
